import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  useTheme,
  Link,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useSnackbar } from "notistack";
import { useNavigate } from 'react-router-dom';
import { axiosInstance as axios, endpoint } from "../../api/axios";
import { useDispatch, useSelector } from 'react-redux';
import { resetUser } from '../../redux/slice/user';
import { persistor } from '../../redux/store';
import DrGadgetLogo from '../../assets/img/dr-gadget.png';
import { setUser, updateUserId } from '../../redux/slice/user';


const Pin = () => {
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const currentUserId = useSelector((state) => state.user.currentUserId);
  const currentUser = useSelector((state) => {
    const id = state.user.currentUserId;
    return state.user.users[id];
  });
  const dispatch = useDispatch();
  

  const handleChange = (value) => {
    setPin(value);
  };

  const handleForgotPin = () => {

    navigate('/forgot-pin', { state: { triggerResend: true } });
    
    
  };


  const handleBackToLogin= () => {
    dispatch(resetUser()); 
    persistor.purge();    
    navigate('/'); 
  };


  const hasVerified = useRef(false); 

useEffect(() => {
  const controller = new AbortController();
  let isMounted = true;

  const verifyPin = async () => {
    const controller = new AbortController();
    let isMounted = true;  

    setLoading(true);
    try {
      const payload = {
        email: currentUser?.email,
        pin: pin,
      };

      const response = await axios.post(endpoint.auth.login, payload, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        signal: controller.signal,
      });

      const valueUser = response.data?.data?.user;
      const valueCredential = response.data?.data;

      if (!valueUser || !valueCredential) {
        throw new Error("Data user tidak valid");
      }

      if (isMounted) {
        hasVerified.current = true; 
        enqueueSnackbar("Login berhasil!", { variant: "success" });

         
         setTimeout(() => {
          navigate('/dashboard');
        }, 100); 

        dispatch(setUser({
          id: valueUser.id,
          name: valueUser.name,
          email: valueUser.email,
          mobile: valueUser.mobile,
          address: valueUser.address,
          token: valueCredential.access_token,
          token_type: valueCredential.token_type,
          branch_name: valueUser.branch_name,
          staff_id: valueUser.staff_id,
          employee_image: valueUser.employee_image,
          isLoggedIn: true,
        }));

        if (currentUserId && currentUserId.startsWith("user-")) {
          dispatch(updateUserId({ oldId: currentUserId, newId: valueUser.id }));
        }

       
      }

    } catch (error) {
      if (isMounted && !hasVerified.current) {
        enqueueSnackbar("Email atau Pin salah silahkan periksa kembali, atau ganti akun !", { variant: "error" });
      }
    } finally {
      if (isMounted) setLoading(false);
    }
  };

  if (pin.length === 6 && !hasVerified.current) {
    verifyPin();
  }

  return () => {
    isMounted = false;
    controller.abort();
  };
}, [pin, currentUser?.email, currentUserId, navigate]);
  


  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: 30,
          width: "100%",
          textAlign: "center",
          zIndex: 10,
        }}
      >
       <img
        src={DrGadgetLogo} 
        alt="Dr Gadget Indonesia"
        style={{
          width: isMobile ? "80%" : "60%", 
          maxWidth: "15%",
          height: "auto",
          objectFit: "contain",
          boxShadow: "0 0 6px rgba(211, 205, 205, 0.5)",
        }}
      />
      </Box>

      <Box
        sx={{
          minHeight: "100vh",
          backgroundImage: "url('/background.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: isMobile ? 1 : 3,
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={isMobile ? 1 : 3}
            sx={{
              p: isMobile ? 2 : 5,
              borderRadius: isMobile ? 2 : 4,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <Typography
              variant={isMobile ? "h6" : "h5"}
              gutterBottom
              sx={{ fontWeight: 500, textAlign: "center", color: "text.secondary" }}
            >
              Masukkan PIN
            </Typography>

            <Box sx={{ mb: isMobile ? 2 : 3, position: "relative" }}>
              <MuiOtpInput
                value={pin}
                onChange={handleChange}
                length={6}
                TextFieldsProps={{
                  inputProps: {
                    inputMode: "numeric",
                  },
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  },
                  sx: {
                    width: isMobile ? 36 : 44,
                    height: isMobile ? 42 : 48,
                    mx: 0.5,
                  },
                }}
                sx={{ justifyContent: "center", mb: isMobile ? 2 : 3 }}
              />
              {loading && (
                <CircularProgress
                  size={50}
                  sx={{
                    position: "absolute",
                    right: "50%",
                    top: "50%",
                    transform: "translate(50%, -50%)",
                  }}
                />
              )}
            </Box>

            <Typography
              variant="body2"
              align="center"
              sx={{ mb: isMobile ? 1.5 : 2, fontSize: isMobile ? 14 : 16 }}
            >
              <Link onClick={handleForgotPin}  component="button"
                  underline="hover" color="text.secondary">
                Lupa PIN?
              </Link>
            </Typography>

            <Button
              variant="contained"
              color="primary"
              size={isMobile ? "medium" : "large"}
              fullWidth
              onClick={handleBackToLogin}
              sx={{ borderRadius: 999 }}
              endIcon={<ArrowForwardIcon />}
            >
              Ganti Akun
            </Button>
          </Paper>
        </Container>
      </Box>

    </>
  );
};

export default Pin;
